import { COMMON_MENU } from './COMMON';
import { ACCOUNT_MENU } from './ACCOUNT_MENU';
import { PRODUCT_MENU } from './PRODUCT_MENU';
import { STORE_MENU } from './STORE_MENU';
import { ORDER_MENU } from './ORDER_MENU';
import { BALANCE_MENU } from './BALANCE_MENU';
import { PAYMENT_MENU } from './PAYMENT_MENU';
import { TAG_MENU } from './TAG_MENU';
import { PAGE_MENU } from './PAGE_MENU';
import { CATEGORY_MENU } from './CATEGORY_MENU';
import { IMAGE_MENU } from './IMAGE_MENU';
import { PROMOTION_MENU } from './PROMOTION_MENU';
import { EVENT_MENU } from './EVENT_MENU';
import { COUPON_MENU } from './COUPON_MENU';
import { ALIMTALK_MENU } from './ALIMTALK_MENU';
import { POINT_MENU } from './POINT_MENU';
import { NOTICE_MENU } from './NOTICE_MENU';
import { KEYWORD_MENU } from './KEYWORD_MENU';
import { SEARCH_DICTIONARY_MENU } from './SEARCH_DICTIONARY_MENU';
import { INQUIRY_MENU } from './INQUIRY_MENU';
import { REVIEW_MENU } from './REVIEW_MENU';
import { VERSION_MENU } from './VERSION_MENU';
import { RECOMMEND_MENU } from './RECOMMEND_MENU';
import { PermissionTableRowType } from '../../../../../../types/common/PermissionType';
import { MULTI_CHANNEL_MENU } from './MULTI_CHANNEL_MENU';

export const PERMISSION_TABLE_MODEL: PermissionTableRowType[] = [
  /* 공통 */
  COMMON_MENU,
  /* 계정 */
  ACCOUNT_MENU,
  /* 브랜드 */
  STORE_MENU,
  /* 상품 */
  PRODUCT_MENU,
  /* 주문 */
  ORDER_MENU,
  /* 멀티채널 */
  MULTI_CHANNEL_MENU,
  /* 정산 */
  BALANCE_MENU,
  /* 결제 */
  PAYMENT_MENU,
  /* 태그 */
  TAG_MENU,
  /* 페이지 */
  PAGE_MENU,
  /* 카테고리 */
  CATEGORY_MENU,
  /* 원격 이미지 */
  IMAGE_MENU,
  /* 프로모션 */
  PROMOTION_MENU,
  /* 기획전 */
  EVENT_MENU,
  /* 쿠폰 */
  COUPON_MENU,
  /* 알림톡 발송 */
  ALIMTALK_MENU,
  /* 포인트 */
  POINT_MENU,
  /* 공지 */
  NOTICE_MENU,
  /* 키워드 */
  KEYWORD_MENU,
  /* 검색 사전 */
  SEARCH_DICTIONARY_MENU,
  /* 공지 */
  INQUIRY_MENU,
  /* 리뷰 */
  REVIEW_MENU,
  /* 버전 */
  VERSION_MENU,
  /* 추천 */
  RECOMMEND_MENU,
];
